export const urls = {
  getAllUsers: 'users',
}
